const translations = {
  da: {
    // Login
    loginSubtitle: "Log ind med din Podio-konto",
    loginTitle: "Log ind",
    loginEmail: "Podio Email",
    loginEmailPlaceholder: "din@email.dk",
    loginPassword: "Password",
    loginPasswordPlaceholder: "Dit Podio password",
    loginButton: "Log ind med Podio",
    loginLoading: "Logger ind...",
    loginRemember: "Husk mig",
    loginFooter: "Brug samme login som din Podio-konto",
    loginWrongCredentials: "Forkert email eller password",
    loginServerError: "Server fejl - prøv igen",
    loginGenericError: "Noget gik galt. Prøv igen.",

    // Dashboard
    loadingDashboard: "Indlæser dashboard...",
    adminDashboard: "Admin Dashboard",
    staffDashboard: "Medarbejder Dashboard",
    studentDashboard: "Elev Dashboard",
    tabStaff: "Omsætning",
    tabStudent: "Score",

    // Periods
    periodDay: "Dag",
    periodWeek: "Uge",
    periodMonth: "Måned",
    periodLastMonth: "Sidste md.",
    periodPrevMonth: "Forrige md.",
    periodSuffixDay: "i dag",
    periodSuffixWeek: "denne uge",
    periodSuffixMonth: "denne måned",
    periodSuffixLastMonth: "sidste måned",
    periodSuffixPrevMonth: "forrige måned",

    // Header
    dataSourceLive: "GeckoBooking Live",
    dataSourceReady: "Gecko Klar",
    dataSourceDemo: "Demo Data",
    syncButton: "Sync",
    syncButtonRunning: "Syncer...",
    statusLive: "Live",
    statusDemo: "Demo",
    syncProgress: "Synkroniserer...",
    syncStarting: "Starter sync...",
    roleAdmin: "Admin",
    roleMember: "Medarbejder",
    roleGuest: "Elev",
    roleUser: "Bruger",

    // Staff view
    kpiServices: "Ydelser",
    kpiServicesSub: (n) => `${n} behandlinger`,
    kpiProducts: "Produkter",
    kpiProductsSub: (n) => `${n} salg`,
    kpiGiftcards: "Gavekort",
    kpiGiftcardsSub: (n) => `${n} solgt`,
    kpiTotal: "Samlet",
    kpiTotalSub: (n) => `${n} transaktioner`,
    deptRanking: (period) => `Afdelingsranking - ${period}`,
    popularProducts: "Populære Produkter",
    popularTreatments: "Populære Behandlinger",

    // Student view
    deptRankingQty: "Afdelingsranking - Antal behandlinger",
    topStudentsOverall: "Top Elever Overall",
    topStudentsSubtitle: (period) => `Samlet performance ${period} - omsætning, produkter, gavekort og klippekort`,
    topStudentsByCity: "Top Elever pr. By",
    topStudentsByCitySubtitle: (period) => `Antal solgte produkter ${period}`,

    // Popular item
    currentMonth: "Indeværende måned",

    // Empty state
    noDataTitle: "Ingen data endnu i dag",
    noDataSubtitle: "Kom tilbage igen senere.",

    // Leaderboard
    pcs: (n) => `${n} stk`,
  },

  en: {
    // Login
    loginSubtitle: "Sign in with your Podio account",
    loginTitle: "Sign in",
    loginEmail: "Podio Email",
    loginEmailPlaceholder: "your@email.com",
    loginPassword: "Password",
    loginPasswordPlaceholder: "Your Podio password",
    loginButton: "Sign in with Podio",
    loginLoading: "Signing in...",
    loginRemember: "Remember me",
    loginFooter: "Use the same login as your Podio account",
    loginWrongCredentials: "Wrong email or password",
    loginServerError: "Server error - please try again",
    loginGenericError: "Something went wrong. Please try again.",

    // Dashboard
    loadingDashboard: "Loading dashboard...",
    adminDashboard: "Admin Dashboard",
    staffDashboard: "Staff Dashboard",
    studentDashboard: "Student Dashboard",
    tabStaff: "Staff",
    tabStudent: "Score",

    // Periods
    periodDay: "Day",
    periodWeek: "Week",
    periodMonth: "Month",
    periodLastMonth: "Last month",
    periodPrevMonth: "Prev. month",
    periodSuffixDay: "today",
    periodSuffixWeek: "this week",
    periodSuffixMonth: "this month",
    periodSuffixLastMonth: "last month",
    periodSuffixPrevMonth: "previous month",

    // Header
    dataSourceLive: "GeckoBooking Live",
    dataSourceReady: "Gecko Ready",
    dataSourceDemo: "Demo Data",
    syncButton: "Sync",
    syncButtonRunning: "Syncing...",
    statusLive: "Live",
    statusDemo: "Demo",
    syncProgress: "Synchronising...",
    syncStarting: "Starting sync...",
    roleAdmin: "Admin",
    roleMember: "Staff",
    roleGuest: "Student",
    roleUser: "User",

    // Staff view
    kpiServices: "Services",
    kpiServicesSub: (n) => `${n} treatments`,
    kpiProducts: "Products",
    kpiProductsSub: (n) => `${n} sales`,
    kpiGiftcards: "Gift Cards",
    kpiGiftcardsSub: (n) => `${n} sold`,
    kpiTotal: "Total",
    kpiTotalSub: (n) => `${n} transactions`,
    deptRanking: (period) => `Department Ranking - ${period}`,
    popularProducts: "Popular Products",
    popularTreatments: "Popular Treatments",

    // Student view
    deptRankingQty: "Department Ranking - Treatments",
    topStudentsOverall: "Top Students Overall",
    topStudentsSubtitle: (period) => `Overall performance ${period} - revenue, products, gift cards and clip cards`,
    topStudentsByCity: "Top Students by City",
    topStudentsByCitySubtitle: (period) => `Products sold ${period}`,

    // Popular item
    currentMonth: "Current month",

    // Empty state
    noDataTitle: "No data yet today",
    noDataSubtitle: "Check back later.",

    // Leaderboard
    pcs: (n) => `${n} pcs`,
  },
};

export const t = (lang, key, ...args) => {
  const locale = lang === "en" ? "en" : "da";
  const val = translations[locale][key];
  if (typeof val === "function") return val(...args);
  return val ?? key;
};

export default translations;
